'use strict';
import {buildQueueIdGenerator} from '../../core-utilities/redux/utils';

export const ACTIVE_TIMERS_QUEUE_NAME = 'activeTimersQueue';
const prefix = `@@${ACTIVE_TIMERS_QUEUE_NAME}`;

export const queueIdGenerator = buildQueueIdGenerator(prefix);



// WEBPACK FOOTER //
// ./src/js/timers/actions/activeTimersQueueActions.js